<div class="container-fluid">
  <div class="row">
    <div class="col-12 text-center">
      <img src="assets/images/page-not-found.jpg" class="img-fluid">

      <h5>Sorry! Page Not Found.</h5>

      <a routerLink="/retailer" class="btn btn-primary text-white text-uppercase fw-bold">Back</a>
    </div>
  </div>
</div>
